/* emv/types */
import * as t from "io-ts";

function tOptional<T extends t.Mixed>(typeThing: T) {
  return t.union([t.undefined, t.null, typeThing]);
}
const tId = t.union([t.undefined, t.null, t.string]);

const ErrorCodec = t.type(
  {
    code: t.string,
    detail: t.string,
    title: t.string,
  },
  "ErrorCodec"
);

const PaymentTypeSchema = t.partial({
  ProductID: t.string,
  ProductName: t.string
})

const PaymentTypeGroupSchema = t.partial({
  CDOLimit: t.number,
  FloorLimit: t.number,
  GroupID: t.string,
  GroupName: t.string,
  PaymentMethod: t.array(t.string),
  PaymentType: t.array(PaymentTypeSchema),
  TransType: t.array(t.string),
  forceSignature: t.string,
  HostResponseCheck: t.string
});

const AttributeCodec = t.intersection([
  t.type({
    Group: t.array(PaymentTypeGroupSchema),
    Name: t.string
  }),
  t.partial({}),
]);

const DataCodec = t.type({
  id: tId,
  type: t.string,
  attributes: AttributeCodec,
});
export type Data = t.TypeOf<typeof DataCodec>;

export const OfflinePaymentTypeGroupCodec = t.type(
  {
    errors: tOptional(t.union([t.undefined, t.array(ErrorCodec)])),
    data: tOptional(t.array(DataCodec)),
  },
  "OfflinePaymentTypeGroupCodec"
);

export type OfflinePaymentTypeGroup = t.TypeOf<typeof OfflinePaymentTypeGroupCodec>;

export enum OfflinePaymentTypeGroupActionTypes {
  FETCH = "@@offlinePaymentTypeGroup/FETCH",
  FETCH_SUCCESS = "@@offlinePaymentTypeGroup/FETCH_SUCCESS",
  FETCH_ERROR = "@@offlinePaymentTypeGroup/FETCH_ERROR",
}

export interface OfflinePaymentTypeGroupState {
  readonly loading: boolean;
  readonly data: Data[];
  readonly errors?: string;
}
